import React, { Component } from 'react';
import config from '../../../config';
import DataTable from '../../widgets/DataTable';

const getTipoTercero = (esCliente, esProveedor) => {
    if (esCliente === 1 && esProveedor === 1) return 'Cliente y Proveedor';
    if (esCliente === 1) return 'Cliente';
    if (esProveedor === 1) return 'Proveedor';
    return 'No Especificado';
};

const COLUMNS = [
    { key: 'ID_EMPRESA',             label: 'Empresa' },
    { key: 'DOCUMENTO_CLIENTE',      label: 'Código',         sortable: true },
    { key: 'NOMBRE_CLIENTE',         label: 'Nombre',         sortable: true },
    { key: 'TIPO',                   label: 'Tipo',           render: (_, row) => getTipoTercero(row.ES_CLIENTE, row.ES_PROVEEDOR) },
    { key: 'NOMBRE_ESTABLECIMIENTO', label: 'Establecimiento' },
];

class Clientes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            empresa: sessionStorage.getItem('company'),
            tipo:    sessionStorage.getItem('tipo'),
            loading: true,
        };
    }

    componentDidMount() {
        fetch(config.servBackEnd + '/clients/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo':    this.state.tipo,
            },
        })
            .then(r => r.json())
            .then(data => this.setState({ data, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        return (
            <DataTable
                title="Clientes y Proveedores"
                columns={COLUMNS}
                data={this.state.data}
                loading={this.state.loading}
                searchKeys={['DOCUMENTO_CLIENTE', 'NOMBRE_CLIENTE', 'NOMBRE_ESTABLECIMIENTO']}
                searchPlaceholder="Buscar por Nit, Nombre o Establecimiento..."
                createUrl="/clientes/crear/"
                createLabel="Crear Cliente"
                editUrl="/clientes/crear/"
                editKey="ID_CLIENTES"
            />
        );
    }
}

export default Clientes;


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/clientes.jsx